<template>
  <v-container
      fluid
  >
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <v-data-table
            class="clickable"
            :headers="headers"
            :loading="loading"
            :items="items"
            :options.sync="options"
            :items-per-page-items="itemsPerPageItems"
            :server-items-length="totalItems"
            @click:row="showDialog"
          >
            <template v-slot:item.created_at="{ item }">
              <span>{{ myFormatDate(item.created_at) }}</span>
            </template>

            <template v-slot:top>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-folder-search"
                    label="Search target subject"
                    single-line
                    hide-details
                    clearable
                    class="ml-3"
                  ></v-text-field>
                </v-col>

                <v-col cols="3">
                  <v-select
                    v-model="userId"
                    :items="users"
                    label="User"
                    clearable
                  >
                </v-select>
                </v-col>


                <v-col cols="2">
                  <v-select
                    v-model="module"
                    :items="modules"
                    label="Module"
                    clearable
                  >
                </v-select>
                </v-col>

                <v-col cols="2">
                  <v-select
                    ref="listActions"
                    v-model="action"
                    :items="actions"
                    label="Action"
                    clearable
                  >
                </v-select>
                </v-col>

              </v-row>
            </template>

            <template v-slot:no-results>
              <span>{{ $t('No matching data found') }}</span>
            </template>

            <template v-slot:no-data>
              <span>{{ $t('No data available') }}</span>
            </template>
          </v-data-table>

          <ItemDialog ref="itemDialog" @update="fetchItems" />

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import SessionService from '@/services/session.service'
import ItemDialog from '@/components/UserLogDialog'
import { fetchList , DateTime, formatDateTime } from '@/lib/helpers'
import _ from 'lodash'


export default {
  props: ['type'],
  components: {
    ItemDialog,
  },
  data: () => ({

    action: null,
    actions: [],

    module: null,
    modules: [],

    userId: null,
    users: [],

    items: [],
    totalItems: 10,
    loading: true,
    options: {
        itemsPerPage: 10,
    },
    search: '',
    itemsPerPageItems: [5, 10, 25, 50],

  }),
  computed: {
    headers() {
      return [
        { text: this.$t('at'), value: 'created_at', align: 'left', sortable: true, width: '20%' },
        { text: this.$t('by'), value: 'responsible_user', align: 'left', sortable: true, width: '20%' },
        { text: this.$t('module'), value: 'module', align: 'left', sortable: true, width: '10%' },
        { text: this.$t('action'), value: 'action', align: 'left', sortable: true, width: '10%' },
        { text: this.$t('request'), value: 'request', align: 'left', sortable: true, width: '10%' },
        { text: this.$t('requested id'), value: 'request_id', align: 'left', sortable: true, width: '30%' },
      ]
    },
  },
  watch: {
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
    '$i18n.locale': function () {
      this.fetchItems()
    },
    action() {
      this.fetchItems()
    },
    module() {
      this.fetchItems()
    },
    userId() {
      this.fetchItems()
    },
    search() {
      this.fetchItems()
    },
  },
  created() {
    this.$store.dispatch('session/title', this.$t('User log'))
    fetchList(this, 'users', '/users/get-list', 'username', 'v.jansen@netzozeker.nl')
    fetchList(this, 'actions', '/user-log/get-list', 'list', 'actions')
    fetchList(this, 'modules', '/user-log/get-list', 'list', 'modules')
    this.restoreFilters()
  },
  methods: {
    showDialog(item = null) {
      this.$refs.itemDialog.showDialog(item ? item.id : null)
    },
    fetchItems: _.debounce(function() {
      this.loading = true
      this.saveFilters()
      ApiService.index('/user-log', this.options, {
        params: {
          filter: {
            query: this.search,
            action: this.action,
            module: this.module,
            created_by: this.userId
          },
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
    saveFilters() {
      SessionService.setItem('filter_user_log', {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_user_log')
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      }
    },
    myFormatDate(timestamp) {
      return formatDateTime(DateTime.fromSeconds(timestamp))
    },
  }
}
</script>

<style scoped>

</style>

